var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoPark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_616_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M773.912 747.827H732.589L654.734 669.566L732.589 591.305H773.912C788.314 591.305 800 579.628 800 565.217C800 550.806 788.314 539.13 773.912 539.13C597.502 539.13 495.964 539.13 460.869 539.13C446.458 539.13 434.781 550.806 434.781 565.217C434.781 579.628 446.458 591.305 460.869 591.305H503.28L581.133 669.566L503.28 747.827H365.217V572.388C337.966 569.308 311.552 561.471 286.956 549.066C262.361 561.471 235.947 569.308 208.695 572.388V747.827H26.0875C11.6766 747.827 0 759.503 0 773.913C0 788.324 11.6766 800 26.0875 800C676.139 800 117.673 800 773.914 800C788.316 800 800.002 788.324 800.002 773.913C800 759.503 788.314 747.827 773.912 747.827ZM576.883 591.305H658.986L617.936 632.572L576.883 591.305ZM576.883 747.827L617.934 706.56L658.984 747.827H576.883Z",
    fill: "#062134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.395 174.753C465.267 77.6922 385.02 0 286.956 0C189.075 0 108.967 77.4125 104.567 174.223C40.3672 204.616 0 271.305 0 339.13C0 486.098 166.202 573.511 286.956 488.366C407.792 573.569 573.912 486.017 573.912 339.13C573.912 268.513 532.634 204.713 469.395 174.753Z",
    fill: "#062134"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_616_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPark);
export default __webpack_public_path__ + "static/media/ico_park.c612ae23d6fc5cfdd3d1328f6c7d514c.svg";
export { ForwardRef as ReactComponent };